import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Log } from "ng2-logger";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Adhesive } from "@app/strain/config/adhesives/models/adhesive.model";
import { User } from "@app/shared/models";
import {
    StrainMeasurementGageMountingModel
} from "@app/strain/common/models/view-measurement-models/strain-measurement-gage-mounting.model";

@Component({
    selector: 'app-strain-measurement-gage-mounting-form',
    templateUrl: './strain-measurement-gage-mounting-form.component.html',
    styleUrls: ['./strain-measurement-gage-mounting-form.component.scss']
})
export class StrainMeasurementGageMountingFormComponent implements OnInit, OnChanges {

    _logger = Log.create(StrainMeasurementGageMountingFormComponent.name);

    @Input() adhesives: Adhesive[];
    @Input() users: User[];
    @Input() isEditMode: boolean;
    @Input() gageMounting: StrainMeasurementGageMountingModel;

    @Input() showValidations = false;
    @Input() isLoading = false;


    public form: UntypedFormGroup;

    constructor(private fb: UntypedFormBuilder) {
    }

    ngOnInit() {
        this._logger.info("ngOnInit:: Preparing Strain Report Mounting Form");
        this.initForm(this.isEditMode);
    }

    initForm(isEditMode) {
        this.form = this.fb.group({
            adhesive: [null, Validators.required],
            mountedBy: [null, Validators.required],
            mountingDate: [null, Validators.required],
            evaluatedBy: ["", Validators.required],
            evaluationDate: [null, Validators.required]
        });

        if (isEditMode && this.gageMounting) {
            this.load(this.gageMounting);
        }
    }


    control(name: string): UntypedFormControl {
        return this.form.get(name) as UntypedFormControl;
    }

    value() {
        return this.form.value;
    }

    valid() {
        return this.form && this.form.valid;
    }

    reset() {
        this._logger.info("resetForm:: Resetting Strain Report Mounting Form");
        this.form.reset();
    }


    load(entry: StrainMeasurementGageMountingModel) {
        this.form.setValue({
            adhesive: entry.adhesive,
            mountedBy: entry.mountedBy,
            mountingDate: entry.mountingDate,
            evaluatedBy: entry.evaluatedBy,
            evaluationDate: entry.evaluationDate
        });
    }

    ngOnChanges(changes: SimpleChanges): void {

    }
}
